export default __webpack_public_path__ + "assets/3b9b865813caa4bd6284aa8d5ef07895.jpg";